/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Email_ProviderInputs */

const en_admin_settings_fields_email_provider = /** @type {(inputs: Admin_Settings_Fields_Email_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Provider`)
};

/**
* | output |
* | --- |
* | "Email Provider" |
*
* @param {Admin_Settings_Fields_Email_ProviderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_email_provider = /** @type {((inputs?: Admin_Settings_Fields_Email_ProviderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Email_ProviderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_email_provider(inputs)
});
export { admin_settings_fields_email_provider as "admin.settings.fields.email_provider" }